import { render, staticRenderFns } from "./RegistrationFinished.vue?vue&type=template&id=c37aa256&scoped=true&"
import script from "./RegistrationFinished.vue?vue&type=script&lang=js&"
export * from "./RegistrationFinished.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFinished.vue?vue&type=style&index=0&id=c37aa256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37aa256",
  null
  
)

export default component.exports